import React, { useContext, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import { Button, Grid, List, ListItem } from "@mui/material";
import { UserLoginInfo } from "../../types/context";
import { appLogger, Http } from "../../utils";
import { UserContext } from "../../context/userContext";
import { useLocation, useNavigate } from "react-router-dom";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import HelpIcon from "@mui/icons-material/Help";
import Tooltip from "@mui/material/Tooltip";

import {
  IProductParams,
  ICategory,
  FEEDBACK_TYPE_FEEDBACK,
  FEEDBACK_TYPE_BUGS,
  FEEDBACK_TYPE_FEATURE_REQ,
  INVOKE_TYPE_MANUAL,
  INVOKE_TYPE_AFTER_DELAY,
  INVOKE_TYPE_CONTEXT_CHANGE,
  INVOKE_TYPE_IDLE,
  RATING_ICON_TYPE_STAR,
  RATING_ICON_TYPE_HEART,
  RATING_ICON_TYPE_EMOJI,
  PLATFORM_TYPE_BROWSER,
  PLATFORM_TYPE_MOBILE, //, EMAIL_MANDATORY, EMAIL_OPTIONAL
  POS_RIGHT_MIDDLE,
  TRACKING_SYSTEM_SELF,
  FEEDBACK_FLOW_STATIC,
  IFeedbackAgentSettings,
  IProductInfo,
  STATUS_PRODUCT_ACTIVE,
  ITrackingSystem,
  TRACKING_SYSTEM_JIRA,
  TRACKING_SYSTEM_ZENDESK,
  webTechs,
  IEmailConfiguration,
  TYPE_NONE,
  brandingIF,
  FEEDBACK_FLOW_DYNAMIC,
  intelligenceConfiguration,
} from "../../model";
import {
  CompressOutlined,
  ExpandLess,
  ExpandMore,
  StarBorder,
} from "@mui/icons-material";
import Preview from "@mui/icons-material/Preview";
import Joyride, {
  CallBackProps,
  STATUS,
  Step,
  StoreHelpers,
  ACTIONS,
} from "react-joyride";
//import { setNestedObjectValues } from "formik";
import ViewComfyIcon from "@mui/icons-material/ViewComfy";
import { IconWithToolTip } from "../../components/common";
import images from "../../global-styles/images";
import { fontWeight, styled } from "@mui/system";
import { TooltipProps } from "@mui/material";
import { tooltipClasses } from "@mui/material";
import AccountForm from "../../components/add-account/AccountForm";
import {
  defaultConnectionDetails,
  defaultFeatureRequestAISettings,
  defaultFeatureRequestEmailSettings,
  defaultFeedbackAISettings,
  defaultFeedbackEmailSettings,
  defaultTicketAISettings,
  defaultTicketEmailSettings,
} from "../../components/email-settings/constants";
import { uploadFileBucketName } from "../../utils/config";
interface TabPanelProps {
  children?: any;
  index: number;
  value: number;
}

const defaultBranding: brandingIF = {
  "branding-cuvo-popup-dialog-agent-bg": "#f7f8f8",
  "branding-cuvo-popup-dialog-main-title": "#011348",
  "branding-cuvo-popup-dialog-main-title-font-family": "Open Sans",
  "branding-cuvo-popup-dialog-main-title-font-weight": "700",
  "branding-cuvo-popup-dialog-main-title-font-style": "normal",
  "branding-cuvo-popup-dialog-main-title-font-size": "34px",
  "branding-cuvo-popup-dialog-main-subtitle": "#040000",
  "branding-cuvo-popup-dialog-main-subtitle-font-family": "Open Sans",
  "branding-cuvo-popup-dialog-main-subtitle-font-weight": "500",
  "branding-cuvo-popup-dialog-main-subtitle-font-style": "normal",
  "branding-cuvo-popup-dialog-main-subtitle-font-size": "16px",
  "branding-cuvo-popup-dialog-card-bg": "#ffffff",
  "branding-cuvo-popup-dialog-card-title": "#040000",
  "branding-cuvo-popup-dialog-card-title-font-family": "Open Sans",
  "branding-cuvo-popup-dialog-card-title-font-weight": "700",
  "branding-cuvo-popup-dialog-card-title-font-style": "normal",
  "branding-cuvo-popup-dialog-card-title-font-size": "20px",
  "branding-cuvo-popup-dialog-card-subtitle": "#040000",
  "branding-cuvo-popup-dialog-card-subtitle-font-family": "Open Sans",
  "branding-cuvo-popup-dialog-card-subtitle-font-weight": "500",
  "branding-cuvo-popup-dialog-card-subtitle-font-style": "normal",
  "branding-cuvo-popup-dialog-card-subtitle-font-size": "16px",
  "branding-cuvo-primary-button-bg": "#0157ff",
  "branding-cuvo-primary-button-text-color": "#ffffff",
  "branding-cuvo-primary-button-text-font-family": "Open Sans",
  "branding-cuvo-primary-button-text-font-style": "normal",
  "branding-cuvo-primary-button-text-font-weight": "400",
  "branding-cuvo-primary-button-text-font-size": "16px",
  "branding-cuvo-primary-button-border-color": "#0157ff",
  "branding-cuvo-secondary-button-bg": "#00000070",
  "branding-cuvo-secondary-button-text-color": "#ffffff",
  "branding-cuvo-secondary-button-text-font-family": "Open Sans",
  "branding-cuvo-secondary-button-text-font-style": "normal",
  "branding-cuvo-secondary-button-text-font-weight": "400",
  "branding-cuvo-secondary-button-text-font-size": "16px",
  "branding-cuvo-secondary-button-border-color": "#00000070",
  // "branding-cuvo-card-border-color": "#040000",
  // "branding-cuvo-card-border-radius": "2px",
  // "branding-cuvo-button-border-radius": "2px",
  "branding-cuvo-input-label-color": "#040000",
  "branding-cuvo-input-label-font-family": "Open Sans",
  "branding-cuvo-input-label-font-style": "normal",
  "branding-cuvo-input-label-font-weight": "500",
  "branding-cuvo-input-label-font-size": "16px",
  "branding-cuvo-input-field-text-color": "#000",
  "branding-cuvo-input-field-bg-color": "#f4f5f5",
  "branding-cuvo-attachment-helper-color": "#00000060",
  "branding-cuvo-attachment-helper-font-family": "Open Sans",
  "branding-cuvo-attachment-helper-font-style": "normal",
  "branding-cuvo-attachment-helper-font-weight": "500",
  "branding-cuvo-attachment-helper-font-size": "16px",
  "branding-cuvo-card-svg-fg-color": "#0157ff",
  "branding-cuvo-card-svg-bg-color": "#0157ff1a",
  "branding-cuvo-selected-star-color": "#ffbc01",
  "branding-cuvo-unselected-star-color": "#d9d6d6",
  "branding-cuvo-card-border-color": "#00000070",
  "branding-cuvo-card-border-radius": "8px",
  "branding-cuvo-input-border-color": "#00000070",
  "branding-cuvo-input-border-radius": "8px",
  "branding-cuvo-comments-field-height": "100px",
  "branding-cuvo-editor-font-size": "16px",
  "branding-cuvo-editor-font-family": "Open Sans",
  "branding-cuvo-primary_btn-border-radius": "4px",
  "branding-cuvo-secondary_btn-border-radius": "4px",
  "branding-cuvo-selected-start-rating-uri": "",
  "branding-cuvo-unselected-start-rating-uri": "",
};

const defaultFeedbackAgentSettings: IFeedbackAgentSettings = {
  //  platform: PLATFORM_TYPE_BROWSER,
  feedbackTypes: [
    FEEDBACK_TYPE_FEEDBACK,
    FEEDBACK_TYPE_BUGS,
    FEEDBACK_TYPE_FEATURE_REQ,
  ],
  showLogo: false,
  invokeDelay: 5,
  invokeOn: [INVOKE_TYPE_MANUAL],
  thanksStr: "Thank You",
  title: "Cuvo - Customer Voice",
  subtitle: "Voice your idea or concerns with audio-visual enhancement",
  uploadFileMaxSize: "400",
  videoAudioMaxDuration: "1.5",
  disableDefaultBtn: false,
  disableCuvo: false,
  requireEmail: true,
  captureSystemDetails: true,
  remoteBtns: [],
  widgetLookAndFeel: {
    bgColor: "#042e5b",
    fgColor: "#ffffff",
    font: "inherit",
    fontWeight: 400,
    fontStyle: "normal",
    text: "Feedback",
    icon: "",
    position: POS_RIGHT_MIDDLE,
    custom: {
      top: "",
      bottom: "",
      right: "",
      left: "",
      borderRadius: "",
      rotation: "",
      margin: "",
      padding: "",
    },
  },
  bugSettings: {
    categories: [],
    severities: ["High", "Medium", "Low"],
    categoryHeading: "Choose the area where you noticed the issue",
    severityHeading: "Severity of the issue",
    stdFeedbackHeading: "Choose all options that relate to the issue",
    generalCommentsHeading: "Describe your issue",
    attachmentHelp:
      "Choosing attachment will ask for permission to access required system resources. Please provide access for the attachments to work. The feedback dialog might close and allow you to navigate to any app page. Press capture or stop or open buttons in the dialog or toolbar to attach.",
    dialogMsg:
      "Help us understand better with audio/video/screenshot attachment",
    thanksMsg: "We will attend to your concern.",
    icon: `https://${uploadFileBucketName}.s3.amazonaws.com/bugIcon.png`,
    title: "Report an issue",
    tooltip: "Tell us your concern",
    reqComments: true,
    reqDisplayEmail: false,
    showSeverity: true,
    reqCategory: false,
  },
  feedbackSettings: {
    type: FEEDBACK_FLOW_STATIC,
    categories: [],
    ratingIcon: RATING_ICON_TYPE_STAR,
    ratingLimit: 3,
    categoryHeading: "Choose the area related to your feedback",
    ratingHeading: "How would you rate us",
    stdFeedbackHeading: "Choose all options that relate to your feedback",
    generalCommentsHeading: "Anything more you want us to know",
    attachmentHelp:
      "Choosing attachment will ask for permission to access required system resources. Please provide access for the attachments to work. The feedback dialog might close and allow you to navigate to any app page. Press capture or stop or open buttons in the dialog or toolbar to attach.",
    dialogMsg:
      "Help us understand better with audio/video/screenshot attachment",
    thanksMsg: "We appreciate your feedback",
    icon: `https://${uploadFileBucketName}.s3.amazonaws.com/feedbackIcon.png`,
    title: "Provide Feedback",
    tooltip: "Tell us your experience",
    reqComments: true,
    reqDisplayEmail: false,
    reqCategory: false,
  },
  featureReqSettings: {
    categories: [],
    categoryHeading: "Choose the area related to your request",
    stdFeedbackHeading: "Choose all options that relate to your request",
    generalCommentsHeading: "Describe your request",
    attachmentHelp:
      "Choosing attachment will ask for permission to access required system resources. Please provide access for the attachments to work. The feedback dialog might close and allow you to navigate to any app page. Press capture or stop or open buttons in the dialog or toolbar to attach.",
    dialogMsg:
      "Are there any feature or enhacements that could make your experience better?",
    thanksMsg: "We appreciate your thoughts and consideration",
    icon: `https://${uploadFileBucketName}.s3.amazonaws.com/featureIcon.png`,
    title: "Request a feature",
    tooltip: "How could we enhance your experience",
    reqComments: true,
    reqCategory: false,
  },
  bannerType: TYPE_NONE,
  bannerImage: "",
  bannerText: "",
  branding: defaultBranding,
  qrSettings: {
    addQR: true,
    qrHeading: "Scan this QR code with your phone",
    qrSubHeading:
      "To provide additional context on your query, please scan the QR code below. You will have an option to submit a screenshot, screen recording or audio recording.",
  },
};

const defaultTrackingSystemSettings: ITrackingSystem = {
  feedbackTypes: [
    FEEDBACK_TYPE_FEEDBACK,
    FEEDBACK_TYPE_BUGS,
    FEEDBACK_TYPE_FEATURE_REQ,
  ],
  configs: {
    [FEEDBACK_TYPE_BUGS]: {
      auth: {},
      type: "SELF",
    },
    [FEEDBACK_TYPE_FEATURE_REQ]: {
      auth: {},
      type: "SELF",
    },
    [FEEDBACK_TYPE_FEEDBACK]: {
      auth: {},
      type: "SELF",
    },
  },
};

const defaultEmailConfig: IEmailConfiguration = {
  feedbackTypes: [],
  emailText: {},
  emailSubject: {
    [FEEDBACK_TYPE_BUGS]: "Thank you for reporting tickets",
    [FEEDBACK_TYPE_FEATURE_REQ]: "Thank you for providing feature request",
    [FEEDBACK_TYPE_FEEDBACK]: "Thank you for providing feedback",
  },
  emailSalutation: {},
  emailSignature: {},
  emailOpeningParagraph: {},
  emailClosingParagraph: {},
  ratingLimit: {},
  severityLimit: {},
};

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const AddAccounts = (props: any) => {
  const navigate = useNavigate();
  const location: any = useLocation();
  appLogger.info({
    infoObj: {
      method: "AddAccounts",
      component: "add-products",
      fileName: "index.tsx",
      location: location,
    },
  });
  const [value, setValue] = useState(0);
  const [widgetActionValue, setWidgetActionValue] = useState<any>();
  const {
    userInfo,
    orgId,
    setcontextRedirectProdPage,
    setWidgIntgSettingsAccordianContext,
    enabledFeatures,
    BasicDetailAccordianContext,
    setWalkthroughStepIndex,
    WalkthroughStepIndex,
  } = useContext(UserContext) as UserLoginInfo;
  // const [feedbackAgentSettingsFetched, setFeedbackAgentSettingsFetched] =
  //   useState(false);
  const [productParams, setProductParams] = useState<
    IProductParams | undefined
  >();
  const [isLoading, setIsLoading] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const [clickedItem, setclickedItem] = useState("");
  const [errMsg, setErrMsg] = useState({});
  const [checkConsistency, setCheckConsistency] = useState(true);
  const [products, setProducts] = React.useState([] as any);
  const [run, setRun] = useState(false);
  const [tooltipIsOpen, setTooltipIsOpen] = React.useState(false);

  const items: any = [
    {
      id: 1,
      title: "agentpreview",
    },
    {
      id: 2,
      title: "help",
    },
  ];

  useEffect(() => {
    if (location.state && location.state.productParams) {
      setProductParams(location.state.productParams);
    }
  });

  useEffect(() => {
    if (location.state != null && location.state.id && location.state.version) {
      setIsLoading(true);
      Http.get({
        url: `/api/v2/products/${location.state.id}/${location.state.version}`,
        state: userInfo,
      })
        .then((response: any) => {
          setIsLoading(false);
          appLogger.info({
            infoObj: {
              method: "useEffect",
              component: "add-products",
              fileName: "index.tsx",
              productResponse: response,
            },
          });
          response.products[0] = checkAndSetDefaultValues(response.products[0]);
          if (location && location.state && location.state.cloneNewProduct) {
            response.products[0].id = "";
            response.products[0].version = "";
            response.products[0].name = "";
            response.products[0].apiKey = "";
            response.products[0].cloneNewProduct = true;
          } else if (
            location &&
            location.state &&
            location.state.cloneNewVersion
          ) {
            response.products[0].version = "";
            response.products[0].apiKey = "";
            response.products[0].cloneNewVersion = true;
          }
          setProductParams(response);

          // setFeedbackAgentSettingsFetched(true);
        })
        .catch((error: any) => {
          appLogger.error({
            errObj: {
              method: "useEffect",
              component: "add-products",
              fileName: "index.tsx",
              err: error,
            },
          });
          // setFailure(true);

          props.snackbarShowMessage("products fetch error", "error", 3000);
        });
    } else {
      const newProd = checkAndSetDefaultValues({
        id: "",
        version: "",
        name: "",
        status: STATUS_PRODUCT_ACTIVE,
        platform: PLATFORM_TYPE_BROWSER,
        technology: webTechs[0].value,
        orgId:
          (userInfo && userInfo.userDetails && userInfo.userDetails.orgId) ||
          orgId,
      });

      appLogger.info({
        infoObj: {
          method: "useEffect",
          component: "add-products",
          fileName: "index.tsx",
          newProd: newProd,
        },
      });

      setProductParams({ products: [newProd] });
    }
  }, []);

  useEffect(() => {
    if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].id &&
      checkConsistency &&
      !(location && location.state && location.state.cloneNewVersion)
    )
      checkProductConfigConsistency();
  }, [productParams]);

  function checkProductConfigConsistency() {
    if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].id &&
      checkConsistency
    ) {
      if (basicSettingsMandatoryCheck()) {
        setCheckConsistency(false);
      } else {
        props.snackbarShowMessage(
          "Some mandatory fields are not set for your product. Please check and fix them.",
          "error",
          3000
        );
        setCheckConsistency(false);
      }
    }
  }

  function checkAndSetDefaultValues(product: IProductInfo): IProductInfo {
    if (!product.feedbackAgentSettings) {
      product.feedbackAgentSettings = defaultFeedbackAgentSettings;
    }
    if (!product.emailConfig) {
      // product.emailConfig = defaultEmailConfig;
      product.emailConfig = {
        FEEDBACK: {
          aiSettings: defaultFeedbackAISettings,
          connectionDetails: defaultConnectionDetails,
          emailSettings: defaultFeedbackEmailSettings,
        },
        BUGS: {
          aiSettings: defaultTicketAISettings,
          connectionDetails: defaultConnectionDetails,
          emailSettings: defaultTicketEmailSettings,
        },
        FEATURE_REQUEST: {
          aiSettings: defaultFeatureRequestAISettings,
          connectionDetails: defaultConnectionDetails,
          emailSettings: defaultFeatureRequestEmailSettings,
        },
      };
    }
    if (!product.trackingSystem) {
      product.trackingSystem = defaultTrackingSystemSettings;
    }
    if (!product.orgId) {
      product.orgId =
        (userInfo && userInfo.userDetails && userInfo.userDetails.orgId) ||
        orgId;
    }
    if (
      product.feedbackAgentSettings &&
      !product.feedbackAgentSettings.branding
    ) {
      product.feedbackAgentSettings.branding = defaultBranding;
    }
    return product;
  }

  function basicSettingsMandatoryCheck(): boolean {
    if (
      !(
        productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].name
      )
    ) {
      props.snackbarShowMessage("You must provide account name", "error", 3000);
      const updatedValue = { productNameErr: "You must provide account name" };
      setErrMsg((errMsg) => ({
        ...{},
        ...updatedValue,
      }));
      return false;
    }

    if (
      !(
        productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].version
      )
    ) {
      props.snackbarShowMessage("You must provide  version", "error", 3000);
      const updatedValue = {
        productVersionErr: "You must provide  version",
      };
      setErrMsg((errMsg) => ({
        ...{},
        ...updatedValue,
      }));
      return false;
    }

    if (
      !(
        productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].platform
      )
    ) {
      props.snackbarShowMessage(
        "You must provide product platform",
        "error",
        3000
      );
      const updatedValue = {
        productPlatformErr: "You must provide product platform",
      };
      setErrMsg((errMsg) => ({
        ...{},
        ...updatedValue,
      }));
      return false;
    }
    return true;
  }

  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
  };

  const HandleCancel = () => {
    navigate("/accounts");
  };

  const HandleSave = (e: any) => {
    const postData = productParams;
    let isCloneProduct = false;
    let isCloneVersion = false;
    if (basicSettingsMandatoryCheck()) {
      setIsLoading(true);
      if (
        productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].id
      ) {
        if (products && products.productNameList.length > 0) {
          if (
            productParams.products[0].cloneNewVersion ||
            (location?.state?.version &&
              location?.state?.version != productParams.products[0].version)
          ) {
            const test = products.productNameList.filter(
              (e: any) => e.id == productParams.products[0].id
            );
            const test1 = test.filter(
              (e: any) => e.version == productParams.products[0].version
            );
            if (test1 && test1.length > 0) {
              props.snackbarShowMessage(
                "Version Already Exists! Please try some other version",
                "error"
              );
              setIsLoading(false);
            } else {
              if (
                postData &&
                postData.products &&
                postData.products[0] &&
                postData.products[0].cloneNewVersion
              ) {
                // Remove kbArticle details whlie clone new version
                if (
                  postData &&
                  postData.products[0] &&
                  postData.products[0] &&
                  postData.products[0].chatAgentSettings
                ) {
                  if (
                    postData.products[0].chatAgentSettings.aiSetting?.openaiKey
                  ) {
                    delete postData.products[0].chatAgentSettings.aiSetting
                      .openaiKey;
                  }
                  if (
                    postData.products[0].chatAgentSettings.aiSetting
                      ?.intelligenceLayer
                  ) {
                    const intellLayer: intelligenceConfiguration[] = [];
                    postData.products[0].chatAgentSettings.aiSetting.intelligenceLayer.map(
                      (e) =>
                        intellLayer.push({
                          ...e,
                          question_embedding: [],
                        })
                    );
                    postData.products[0].chatAgentSettings.aiSetting.intelligenceLayer =
                      intellLayer;
                  }
                  if (
                    postData.products[0].chatAgentSettings.aiSetting
                      ?.kbUrlSettings
                  ) {
                    delete postData.products[0].chatAgentSettings.aiSetting
                      .kbUrlSettings;
                  }
                  if (
                    postData.products[0].chatAgentSettings.aiSetting?.kbArticles
                  ) {
                    postData.products[0].chatAgentSettings.aiSetting.kbArticles =
                      [];
                  }
                }
                delete postData.products[0].cloneNewVersion;
                isCloneVersion = true;
              }
              // putUpdate(postData);
              Http.post({
                url: `/api/v2/products`,
                body: {
                  ...postData,
                },
                state: userInfo,
              })
                .then((response: any) => {
                  if (response) {
                    if (response.message === "Product already exists") {
                      props.snackbarShowMessage(
                        "product already exists",
                        "error",
                        3000
                      );
                    } else if (
                      response &&
                      response.message ==
                        "Deletion is currently in progress for a given product ID and version, so the product was not created."
                    ) {
                      props.snackbarShowMessage(
                        response.message,
                        "error",
                        3000
                      );
                      if (
                        postData &&
                        postData.products &&
                        postData.products[0]
                      ) {
                        postData.products[0].cloneNewVersion = true;
                      }
                      isCloneVersion = true;
                    } else {
                      if (productParams) {
                        //Once create the product update product list api
                        getProductList();
                        const temp: IProductParams | undefined = {
                          ...productParams,
                        };
                        if (response.message && response.message.prodId) {
                          temp.products[0].id = response.message.prodId;
                        }
                        setWidgIntgSettingsAccordianContext(true);
                        if (response.message && response.message.apiKey) {
                          temp.products[0].apiKey = response.message.apiKey;
                        }
                        if (response.message && response.message.apiKeyId) {
                          temp.products[0].apiKeyId = response.message.apiKeyId;
                        }
                        //update the product in location so it consisder as update product instead of new clone version
                        navigate("", { state: temp[0] });
                        setProductParams(temp);
                        if (isCloneProduct || isCloneVersion) {
                          props.snackbarShowMessage(
                            "product created, Please configure the required fields, like openAPI Key and knowledge Base",
                            "warning",
                            3000
                          );
                        } else {
                          props.snackbarShowMessage(
                            "product created successfully",
                            "success",
                            3000
                          );
                        }
                        setTimeout(() => {
                          navigate("/accounts", {
                            state: "",
                          });
                        }, 2000);
                      }
                    }
                  }

                  setIsLoading(false);
                })
                .catch((error: any) => {
                  appLogger.error({
                    errObj: {
                      method: "HandleSave",
                      component: "add-products",
                      fileName: "index.tsx",
                      err: error,
                    },
                  });
                  setIsLoading(false);
                  props.snackbarShowMessage(error.message, "error");
                });
            }
            appLogger.info(
              {
                infoObj: {
                  method: "HandleSave",
                  component: "add-products",
                  fileName: "index.tsx",
                  oldVersion: location?.state?.version,
                },
              },
              "Old version"
            );
            appLogger.info(
              {
                infoObj: {
                  method: "HandleSave",
                  component: "add-products",
                  fileName: "index.tsx",
                  newVersion: productParams.products[0].version,
                },
              },
              "New version"
            );
          } else {
            if (
              postData &&
              postData.products &&
              postData.products[0] &&
              postData.products[0].cloneNewVersion
            ) {
              delete postData.products[0].cloneNewVersion;
            }
            putUpdate(postData);
          }
        }
      } else {
        appLogger.info(
          {
            infoObj: {
              method: "HandleSave",
              component: "add-products",
              fileName: "index.tsx",
              productParams: productParams,
            },
          },
          "New product"
        );
        // if (
        //   postData &&
        //   postData.products[0] &&
        //   postData.products[0].technology == "rokuTv" &&
        //   postData.products[0].feedbackAgentSettings &&
        //   postData.products[0].feedbackAgentSettings.branding
        // ) {
        //   const branding: brandingIF =
        //     postData.products[0].feedbackAgentSettings.branding;
        //   branding["branding-cuvo-editor-font-size"] = branding[
        //     "branding-cuvo-editor-font-size"
        //   ].replace("px", "");
        //   branding["branding-cuvo-input-label-font-size"] = branding[
        //     "branding-cuvo-input-label-font-size"
        //   ].replace("px", "");
        //   branding["branding-cuvo-comments-field-height"] = branding[
        //     "branding-cuvo-comments-field-height"
        //   ].replace("px", "");
        //   branding["branding-cuvo-popup-dialog-main-subtitle-font-size"] =
        //     branding[
        //       "branding-cuvo-popup-dialog-main-subtitle-font-size"
        //     ].replace("px", "");
        //   branding["branding-cuvo-popup-dialog-main-title-font-size"] =
        //     branding["branding-cuvo-popup-dialog-main-title-font-size"].replace(
        //       "px",
        //       ""
        //     );
        //   branding["branding-cuvo-primary-button-text-font-size"] = branding[
        //     "branding-cuvo-primary-button-text-font-size"
        //   ].replace("px", "");
        //   branding["branding-cuvo-secondary-button-text-font-size"] = branding[
        //     "branding-cuvo-secondary-button-text-font-size"
        //   ].replace("px", "");
        //   postData.products[0].feedbackAgentSettings.branding = branding;
        // }
        // //Set reqCategory to true if the flow is dynamic while saving the product
        // if (
        //   postData &&
        //   postData.products[0] &&
        //   postData.products[0].feedbackAgentSettings &&
        //   postData.products[0].feedbackAgentSettings.feedbackSettings &&
        //   postData.products[0].feedbackAgentSettings.feedbackSettings.type ==
        //     FEEDBACK_FLOW_DYNAMIC
        // ) {
        //   postData.products[0].feedbackAgentSettings.feedbackSettings.reqCategory =
        //     true;
        // }
        // const prod =
        //     {
        //       "id": postData?.products[0].id,
        //       "version": postData?.products[0].version,
        //       "name": postData?.products[0].name,
        //       "status": postData?.products[0].status,
        //       "platform": postData?.products[0].platform,
        //       "technology": postData?.products[0].technology,
        //       "orgId": postData?.products[0].orgId,
        //     //   "apiKey": postData?.products[0].apiKey,
        //     //   "apiKeyId": postData?.products[0].apiKeyId
        //     }

        if (
          postData &&
          postData.products &&
          postData.products[0] &&
          postData.products[0].cloneNewProduct
        ) {
          isCloneProduct = true;
          //Delete KB articles and use product name as chatbot name for create clone product
          if (
            postData &&
            postData.products[0] &&
            postData.products[0] &&
            postData.products[0].chatAgentSettings
          ) {
            postData.products[0].chatAgentSettings.name =
              postData.products[0]?.name;
            postData.products[0].chatAgentSettings.welcomeMsg = `Welcome to ${postData.products[0]?.name}`;

            if (postData.products[0].chatAgentSettings.aiSetting?.openaiKey) {
              delete postData.products[0].chatAgentSettings.aiSetting.openaiKey;
            }
            if (
              postData.products[0].chatAgentSettings.aiSetting
                ?.intelligenceLayer
            ) {
              const intellLayer: intelligenceConfiguration[] = [];
              postData.products[0].chatAgentSettings.aiSetting.intelligenceLayer.map(
                (e) =>
                  intellLayer.push({
                    ...e,
                    question_embedding: [],
                  })
              );
              postData.products[0].chatAgentSettings.aiSetting.intelligenceLayer =
                intellLayer;
            }
            if (
              postData.products[0].chatAgentSettings.aiSetting?.kbUrlSettings
            ) {
              delete postData.products[0].chatAgentSettings.aiSetting
                .kbUrlSettings;
            }
            if (postData.products[0].chatAgentSettings.aiSetting?.kbArticles) {
              postData.products[0].chatAgentSettings.aiSetting.kbArticles = [];
            }
          }
          delete postData.products[0].cloneNewProduct;
        }

        Http.post({
          url: `/api/v2/products`,
          body: {
            ...postData,
          },
          // body: {
          //   "products": [prod]
          // },
          state: userInfo,
        })
          .then((response: any) => {
            if (response) {
              if (response.message === "Product already exists") {
                props.snackbarShowMessage(
                  "product already exists",
                  "error",
                  3000
                );
                if (postData && postData.products && postData.products[0]) {
                  postData.products[0].cloneNewProduct = true;
                }
                isCloneProduct = true;
              } else if (
                response &&
                response.message ==
                  "Deletion is currently in progress for a given product ID and version, so the product was not created."
              ) {
                props.snackbarShowMessage(response.message, "error", 3000);
                if (postData && postData.products && postData.products[0]) {
                  postData.products[0].cloneNewVersion = true;
                }
                isCloneVersion = true;
              } else {
                if (productParams) {
                  //Once create the product update product list api
                  getProductList();
                  const temp: IProductParams | undefined = { ...productParams };
                  if (response.message && response.message.prodId) {
                    temp.products[0].id = response.message.prodId;
                    if (
                      temp.products[0].feedbackAgentSettings &&
                      temp.products[0].feedbackAgentSettings.bannerImage &&
                      temp.products[0].feedbackAgentSettings.bannerImage != ""
                    ) {
                      temp.products[0].feedbackAgentSettings.bannerImage =
                        response.message.bannerImage;
                    }
                  }
                  setWidgIntgSettingsAccordianContext(true);
                  if (response.message && response.message.apiKey) {
                    temp.products[0].apiKey = response.message.apiKey;
                  }
                  if (response.message && response.message.apiKeyId) {
                    temp.products[0].apiKeyId = response.message.apiKeyId;
                  }
                  //update the product in location so it consisder as update product instead of new clone version
                  navigate("", { state: temp[0] });
                  setProductParams(temp);
                  if (isCloneProduct || isCloneVersion) {
                    props.snackbarShowMessage(
                      "product created, Please configure the required fields, like openAPI Key and knowledge Base",
                      "warning",
                      3000
                    );
                  } else {
                    props.snackbarShowMessage(
                      "product created successfully",
                      "success",
                      3000
                    );
                  }
                }
              }
            }

            setIsLoading(false);
            // setTimeout(() => {
            //   if(e == "create") {
            //     navigate("/add-product", {
            //       state: "",
            //     })
            //   } else {
            //     navigate("/products", {
            //       state: "",
            //     })
            //   };
            // }, 2000);
          })
          .catch((error: any) => {
            appLogger.error({
              errObj: {
                method: "HandleSave",
                component: "add-products",
                fileName: "index.tsx",
                err: error,
              },
            });
            setIsLoading(false);
            props.snackbarShowMessage(error.message, "error");
          });
      }
    }
  };

  const putUpdate = (postData: any) => {
    appLogger.info(
      {
        infoObj: {
          method: "putUpdate",
          component: "add-products",
          fileName: "index.tsx",
          productParams: postData,
        },
      },
      "Update product"
    );
    Http.put({
      url: `/api/v2/products`,
      body: {
        ...postData,
      },
      state: userInfo,
    })
      .then((response: any) => {
        setIsLoading(false);
        if (response && response.message === "Product already exists") {
          props.snackbarShowMessage("Product already exists", "error", 3000);
        } else {
          props.snackbarShowMessage(
            "product saved successfully",
            "success",
            3000
          );
          setTimeout(() => {
            navigate("/accounts", {
              state: "",
            });
          }, 2000);
        }
      })
      .catch((error: any) => {
        appLogger.error({
          errObj: {
            method: "putUpdate",
            component: "add-products",
            fileName: "index.tsx",
            err: error,
          },
        });
        setIsLoading(false);
        props.snackbarShowMessage(error.message, "error");
      });
  };
  const [open, setOpen] = React.useState(false);

  const handleClick = (id: any) => {
    setclickedItem(id);
    setOpen(true);
  };

  useEffect(() => {
    handleClick(1);
  }, []);
  useEffect(() => {
    getProductList();
  }, []);
  const getProductList = () => {
    Http.get({
      url: `/api/v2/products/0`,
      state: userInfo,
    })
      .then((response: any) => {
        appLogger.info({
          infoObj: {
            method: "getProductList",
            component: "add-products",
            fileName: "index.tsx",
            productListResponse: response,
          },
        });

        // const GroupedByBlock = [
        //   ...new Set(response?.productNameList?.map((item: any) => item.id)),
        // ];

        // const tempArray: any = [];

        // if (GroupedByBlock && GroupedByBlock.length) {
        //   GroupedByBlock.forEach((v, i) => {
        //     const newArray = response.productNameList.filter(function (
        //       el: any
        //     ) {
        //       return el.id == v;
        //     });

        //     const arrayObj = {
        //       name: newArray[0].name,
        //       fields: newArray,
        //     };
        //     tempArray.push(arrayObj);
        //   });
        // }

        setProducts(response);

        // const groupBy = (array: any, key: any) => {
        //   return array.reduce((result: any, currentValue: any, i: any) => {
        //     (result[currentValue.orgId] =
        //       result[currentValue.orgId] || []).push(currentValue);
        //     return result;
        //   }, []);
        // };
        // const groupedByProduct = groupBy(response.productNameList, "orgId");

        // setProducts(groupedByProduct);

        // setProducts(response.productNameList);
        setIsLoading(false);
      })
      .catch((error) => {
        appLogger.error({
          errObj: {
            method: "getProductList",
            component: "add-products",
            fileName: "index.tsx",
            err: error,
          },
        });
        setIsLoading(false);
      });
  };

  const handleClose = (id: any) => {
    setOpen(!open);
    setclickedItem("");
  };

  const renderIcon = (title: any) => {
    let icon: any = "";
    if (title == "agentpreview") {
      icon = (
        <Tooltip title="Agent Preview" placement="bottom">
          <Preview />
        </Tooltip>
      );
    } else if (title == "help") {
      icon = (
        <Tooltip title="Help" placement="bottom">
          <HelpIcon />
        </Tooltip>
      );
    }
    // else if (title == "preview") {
    //   icon = (
    //     <Tooltip title="Widget Preview" placement="bottom">
    //       <Preview />
    //     </Tooltip>
    //   );
    // }
    return icon;
  };
  const [scrollElement, setScrollElement] = useState("");
  const [previewScrollElement, setpreviewScrollElement] = useState("");

  const setScroll = (e: any) => {
    setScrollElement(e);
  };
  const setpreviewScroll = (e: any) => {
    setpreviewScrollElement(e);
  };

  const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#0157ff",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      // backgroundColor: theme.palette.common.black,
      backgroundColor: "#0157ff",
    },
  }));

  return (
    <div
      style={{ overflowY: "scroll" }}
      className={isLoading ? "add-products-wrap loader" : "add-products-wrap"}
    >
      <TabPanel value={value} index={0}>
        {/* <Grid container spacing={2}> */}
        <Grid
          item
          xs={12}
          lg={6}
          // className={`add-form-wrap ${open ? "show" : "hide"}`}
        >
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              marginRight: "10px",
            }}
          >
            <Tabs value={value} onChange={handleChange} aria-label="tabs">
              <Tab
                label={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].id
                    ? "edit account"
                    : "add new account"
                }
                {...a11yProps(0)}
              />

              <Button
                type="button"
                variant="outlined"
                sx={{ textTransform: "uppercase" }}
                onClick={HandleCancel}
                className="create-pro-btn "
                id="pro-cancel"
              >
                close
              </Button>

              <Button
                type="submit"
                variant="contained"
                sx={{ textTransform: "uppercase" }}
                onClick={HandleSave}
                className="create-pro-btn guideTourCreateSave"
                id="pro-save"
              >
                {productParams &&
                productParams.products &&
                productParams.products[0] &&
                productParams.products[0].id
                  ? "save"
                  : "create"}
              </Button>
            </Tabs>
          </Box>
        </Grid>
        <AccountForm
          setProductParams={setProductParams}
          productParams={productParams}
          errMsg={errMsg}
          setErrMsg={setErrMsg}
          setScroll={setScroll}
          setpreviewScroll={setpreviewScroll}
          sethandleClick={handleClick}
          getVersionFromEditForm={location?.state?.version}
          saveProduct={HandleSave}
          basicSettingsMandatoryCheck={basicSettingsMandatoryCheck}
          //   generalSettingsMandatoryCheck={generalSettingsMandatoryCheck}
          //   feedbackSettingsMandatoryCheck={feedbackSettingsMandatoryCheck}
          //   bugSettingsMandatoryCheck={bugSettingsMandatoryCheck}
          //   featureSettingsMandatoryCheck={featureSettingsMandatoryCheck}
          //   widgetSettingsMandatoryCheck={widgetSettingsMandatoryCheck}
          //   enabledFeatures={enabledFeatures}
        />

        {/* </Grid>{" "} */}
      </TabPanel>
    </div>
  );
};

export default withSnackbar(AddAccounts);
